module.exports = __webpack_public_path__ + "img/companies_03.fe1a5bce.jpeg";